import React from 'react';
import './PageSkeleton.css';

function PageSkeleton() {
    return (
        <div className="ps-wrap" dir="rtl">
            <div className="ps-hero sk-box" />
            <div className="ps-grid">
                {[1,2,3,4,5,6].map(i => (
                    <div className="ps-card" key={i}>
                        <div className="ps-card__img sk-box" />
                        <div className="ps-card__line sk-box" />
                        <div className="ps-card__line ps-card__line--short sk-box" />
                    </div>
                ))}
            </div>
        </div>
    );
}

export default PageSkeleton;
